import { CONTACT } from "@/data/site";
import { Phone, Mail } from "lucide-react";

export const Footer = () => (
  <footer className="bg-background pt-24 md:pt-32 pb-10" data-testid="site-footer">
    <div className="mx-auto max-w-[1400px] px-6 md:px-8">
      <div className="border-t border-border pt-10 flex flex-col md:flex-row justify-between gap-8">
        <div>
          <p className="font-display uppercase tracking-tight text-xl leading-none">
            Heavy Duty
            <span className="block text-[10px] tracking-[0.35em] text-muted-foreground">DETAILING</span>
          </p>
          <p className="mt-4 text-sm text-muted-foreground max-w-xs">
            Semi-truck detailing & aluminum polishing. Mobile across Nova Scotia.
          </p>
        </div>
        <div className="flex flex-col gap-3">
          <a data-testid="footer-call" href={CONTACT.phoneHref} className="flex items-center gap-2 text-sm hover:text-outline transition-colors">
            <Phone size={15} /> {CONTACT.phone}
          </a>
          <a data-testid="footer-email" href={CONTACT.emailHref} className="flex items-center gap-2 text-sm break-all hover:text-outline transition-colors">
            <Mail size={15} /> {CONTACT.email}
          </a>
        </div>
      </div>
      <div className="mt-12 flex flex-col sm:flex-row justify-between gap-3 text-xs tracking-[0.15em] uppercase text-muted-foreground">
        <span>© {new Date().getFullYear()} Heavy Duty Detailing</span>
        <span>Dartmouth, Nova Scotia · Mobile Service</span>
      </div>
    </div>
  </footer>
);
